import { UserRound } from 'lucide-react'

interface AvatarProps {
  src?: string | null
  alt?: string
  /** Pixel size of the square avatar. */
  size?: number
  className?: string
  /** A name whose first letter stands in when there is no picture (else the person icon). */
  fallbackName?: string | null
}

/** Circular avatar with a person-icon (or initial) fallback, like the iOS AvatarView. */
export function Avatar({ src, alt = '', size = 40, className = '', fallbackName }: AvatarProps) {
  const initial = fallbackName?.trim().replace(/^@+/, '').charAt(0).toUpperCase() ?? ''
  return (
    <span
      className={`bg-surface-hover inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ${className}`}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt={alt} loading="lazy" className="size-full object-cover" />
      ) : initial ? (
        <span
          aria-hidden
          className="text-fg-muted leading-none font-semibold select-none"
          style={{ fontSize: Math.round(size * 0.45) }}
        >
          {initial}
        </span>
      ) : (
        <UserRound className="text-fg-subtle" style={{ width: size * 0.55, height: size * 0.55 }} />
      )}
    </span>
  )
}
